var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _polygon, _path2, _polygon2, _polygon3, _path3, _polygon4, _path4, _path5, _path6, _path7, _path8, _polygon5, _path9, _polygon6, _path10, _path11, _path12, _polygon7, _path13, _path14, _path15, _path16, _polygon8, _path17, _polygon9, _path18, _circle3, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNuevasolicitudCenfotec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 709.02 564.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00479b;}.cls-2{fill:#d1d4d4;}.cls-3{fill:#dbf2fc;}.cls-4{fill:#9cc8ff;}.cls-5{fill:#006aea;}.cls-6{fill:none;stroke:#00479b;}.cls-15,.cls-16,.cls-6{stroke-miterlimit:10;}.cls-7{fill:#deb87d;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#radial-gradient);}.cls-15,.cls-16{stroke:#abd5ef;}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -152.86,
    y1: 276.49,
    x2: -116.17,
    y2: 340.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 406.92, -39.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#afd3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c6e0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e5f3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 842.7,
    y1: 265.83,
    x2: 791.47,
    y2: 354.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61c1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#77c7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8ecded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9ed2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#a8d4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abd5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e6f3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -269.14,
    y1: 267.8,
    x2: 26.63,
    y2: 267.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 406.92, -39.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d6eafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -464.94,
    y1: 622.3,
    x2: -363.57,
    y2: 622.3,
    gradientTransform: "matrix(-0.41, 0.15, 0.13, 0.34, 113.39, 122.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -501.09,
    y1: 330.57,
    x2: -446.59,
    y2: 350.46,
    gradientTransform: "matrix(-0.66, 0.18, 0.24, 0.91, 566.12, 5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -201.18,
    y1: 218.97,
    x2: -145.57,
    y2: 218.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2e3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23486f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -191.84,
    cy: 235.03,
    r: 17.05,
    gradientTransform: "matrix(-0.94, 0, 0, 0.95, 671.88, 39.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -146.54,
    y1: 324.94,
    x2: -146.54,
    y2: 324.94,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -119.63,
    y1: 323.14,
    x2: -119.63,
    y2: 323.14,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -289.68,
    y1: 285.96,
    x2: -236.86,
    y2: 377.43,
    gradientTransform: "matrix(-0.83, 0, 0, 1, 631.31, 0.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 879.32,
    y1: 257.55,
    x2: 815.4,
    y2: 391.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -103.49,
    y1: 314.64,
    x2: -90.42,
    y2: 337.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 790.47,
    y1: 301.14,
    x2: 761.83,
    y2: 350.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -192.1,
    y1: 201.95,
    x2: -141.49,
    y2: 201.95,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 204.43,
    y1: -43.51,
    x2: 226.37,
    y2: -5.49,
    gradientTransform: "matrix(-0.03, -1, -1, 0.03, 562.25, 478.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 886.77,
    y1: 320.52,
    x2: 818.39,
    y2: 283.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 291.74,
    y1: -57.44,
    x2: 324.6,
    y2: -0.54,
    gradientTransform: "matrix(-0.07, -1, -1, 0.07, 522.6, 589.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 844.01,
    y1: 336.46,
    x2: 763.23,
    y2: 297.12,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.21,579.12c-4.86,4.92-7.29,7.38-6.45,9.38,2,4.75,19.76,5.72,31.54-1.58,2.9-1.8,8-5,7.5-9.54-.52-4.81-7-9.37-12.59-10.18C789,566.16,783.87,571.39,776.21,579.12Z",
    transform: "translate(-272.3 -39.64)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 424.6,
    y: 81.05,
    width: 360.14,
    height: 517.26,
    rx: 33.97,
    transform: "translate(937.28 639.28) rotate(179.96)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 441.01,
    y: 92.28,
    width: 348.28,
    height: 499.91,
    rx: 24.34,
    transform: "translate(958.26 644.37) rotate(179.96)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 511.85,
    y: 292.12,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "translate(972.81 561.72) rotate(179.96)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 512.72,
    y: 341.02,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "matrix(-1, 0, 0, -1, 974.58, 659.52)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 512.75,
    y: 380.69,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "translate(974.67 738.85) rotate(179.96)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 512.78,
    y: 420.36,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "translate(974.75 818.19) rotate(179.96)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 518.53,
    y: 155.95,
    width: 104.08,
    height: 89.49,
    rx: 24.34,
    transform: "translate(868.98 361.34) rotate(179.96)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.91,
    y: 25.48,
    width: 104.55,
    height: 40.03,
    rx: 8.46
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 332.17,
    cy: 27.69,
    r: 27.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 461.84,
    cy: 268.62,
    r: 10.76
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "526.69 302.48 514.58 292.49 556.18 234.77 568.29 244.76 526.69 302.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M799,342.44c-4.11-3.32-8.26-6.68-12.35-10.06l-.16-.13.1-.31a85.4,85.4,0,0,1,3.23-8.64c1.19-2.79,2.47-5.53,3.82-8.2,2.7-5.37,5.65-10.55,8.79-15.59,1.58-2.52,3.18-5,4.86-7.47.83-1.22,1.68-2.44,2.53-3.65s1.7-2.43,2.65-3.58a33.92,33.92,0,0,1,6.58-6.22,30.51,30.51,0,0,1,4.14-2.5,23.11,23.11,0,0,1,5-1.87l.42-.1.05,0,12.11,10,.06.44a23.39,23.39,0,0,1,2.71,7.85,18.47,18.47,0,0,1,0,6.31,15.64,15.64,0,0,1-1.84,5.09,17.36,17.36,0,0,1-1.45,2.1l-1.55,2a159,159,0,0,1-13.21,14.87,134.89,134.89,0,0,1-13.73,11.92C807.26,338,803,340.92,799,342.44Zm-.08-.64c3-8.09,5.65-14.83,8.08-21.15s4.71-11.84,7.07-16.94a114.78,114.78,0,0,1,7.59-14l1-1.59a9.54,9.54,0,0,1,1.15-1.51,8.59,8.59,0,0,1,3.36-2.13,16.73,16.73,0,0,1,5.16-.9,35.39,35.39,0,0,1,7.92.63l.06.44-12.11-10,.46-.06a23.27,23.27,0,0,1-.19,5.34,31.14,31.14,0,0,1-1.06,4.71,34.09,34.09,0,0,1-3.82,8.21c-.79,1.26-1.69,2.44-2.56,3.64s-1.77,2.38-2.67,3.56c-1.78,2.37-3.65,4.67-5.54,7-3.79,4.57-7.77,9-12,13.27q-3.17,3.19-6.58,6.22a87.6,87.6,0,0,1-7.17,5.8l-.06-.44C791.06,335.16,795,338.46,799,341.8Z",
    transform: "translate(-272.3 -39.64)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "390.83 278.9 676.06 212.11 665.52 177.42 380.29 244.22 390.83 278.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "344 273.62 392.81 279.78 380.29 244.31 344 273.62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M949.07,252.25,981,245a.5.5,0,0,0,.34-.63l-10.4-34.94a.57.57,0,0,0-.65-.4l-31.88,7.26a.49.49,0,0,0-.34.63l10.4,34.93A.56.56,0,0,0,949.07,252.25Z",
    transform: "translate(-272.3 -39.64)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "597.9 525.74 576.51 526.88 568.29 350.09 589.68 348.95 597.9 525.74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M870.47,565.63c-7.18.44-14.42.88-21.64,1.26h-.32l-.07-.37c-1.5-7.31-2.74-14.63-3.85-22s-2.11-14.67-3-22c-1.79-14.68-3.2-29.38-4.35-44.09s-2-29.43-2.58-44.17a173.72,173.72,0,0,1,.94-22.19c.42-3.71,1-7.43,1.69-11.15a81.93,81.93,0,0,1,2.92-11.21l.14-.38h.22L862,388.22h0l.39.36a43.84,43.84,0,0,1,8.42,11.05,57.33,57.33,0,0,1,4.78,11.62,65.56,65.56,0,0,1,2.28,11.82c.2,2,.28,3.93.33,5.88l.19,5.88c.42,15.65.38,31.27-.13,46.51s-1.43,30.14-2.73,44.33c-.33,3.54-.65,7.06-1,10.5l-.55,5.16-.61,5C872.46,553.06,871.61,559.58,870.47,565.63Zm-.55-.5c-1.82-8.69-3.36-16.9-4.88-25l-1.12-6-1.07-5.89c-.73-3.93-1.39-7.77-2.06-11.6-2.67-15.27-5-29.85-6.84-44.06s-3.29-28.07-4.23-41.88l-.33-5.17c-.12-1.73-.21-3.45-.18-5.17a47.6,47.6,0,0,1,1.25-10.28,50,50,0,0,1,11.15-21.52l.39.36-21.39,1.13.36-.39a81.05,81.05,0,0,1,3.94,10.89q1.61,5.46,2.72,10.95a175.5,175.5,0,0,1,3,22c.83,14.72,1.3,29.46,1.52,44.22s.18,29.52-.24,44.3q-.3,11.08-.94,22.19c-.42,7.4-1,14.81-1.79,22.23l-.39-.36C855.83,565.76,862.85,565.44,869.92,565.13Z",
    transform: "translate(-272.3 -39.64)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M824.79,214.94c.23,15.43,11.7,33.26,27.64,33.34,16.6.08,29.31-19.14,27.86-34.55a28.81,28.81,0,0,0-8.07-16.88c-5.76-5.76-12.14-6.19-21.53-6.83-8.59-.59-12.88-.88-17.16,2.41C824.74,199.19,824.78,214.2,824.79,214.94Z",
    transform: "translate(-272.3 -39.64)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M835.46,278.45l34.27-.34a30.42,30.42,0,0,1-7.45-9.75,24.55,24.55,0,0,1-2.17-6.43,41.46,41.46,0,0,1-.5-6c-.08-1.71-.09-3.44-.1-4.49,0-1.31,0-2.41,0-3.2H844.58c.06.79.14,1.88.2,3.2.08,1.59.15,3.1.1,4.7a32.54,32.54,0,0,1-.6,5.54,28.93,28.93,0,0,1-2.81,7.3A56.76,56.76,0,0,1,835.46,278.45Z",
    transform: "translate(-272.3 -39.64)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M825.76,324.94",
    transform: "translate(-272.3 -39.64)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M798.85,323.14",
    transform: "translate(-272.3 -39.64)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "518.95 513.09 539.92 517.77 573.71 344.5 552.75 339.82 518.95 513.09"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M791.49,552.58l20.79,4.56-.34.22c1.15-14.77,2.88-29.41,4.88-44s4.27-29.15,6.74-43.65,5.13-29,8.06-43.4c1.56-7.19,3.42-14.32,5.7-21.37q1.68-5.3,3.74-10.51a100,100,0,0,1,4.68-10.33l.21.33-21-4.68.34-.22a49.15,49.15,0,0,1,3.82,11.7,60,60,0,0,1,1.16,10.88,64.77,64.77,0,0,1-.71,10.45c-.53,3.45-1.33,6.88-2,10.31-2.9,13.73-6.16,27.43-9.81,41.36s-7.65,28.06-12,42.69S796.76,536.56,791.49,552.58Zm-.47.31c.36-12.87,1.41-26.74,2.65-41s2.91-29,4.88-43.94,4.35-30.13,7.08-45.28c.71-3.78,1.32-7.58,2.2-11.35a80.13,80.13,0,0,1,3.51-11.2,69.19,69.19,0,0,1,5.39-10.79,46.42,46.42,0,0,1,8-9.95l.27-.24.07,0,21,4.68.18,0,0,.29a100.56,100.56,0,0,1,.45,11.33c0,3.74-.19,7.45-.48,11.14-.54,7.39-1.49,14.7-2.75,21.95q-4.07,21.69-8.84,43.24t-10.16,43c-3.64,14.28-7.53,28.5-12,42.62l-.08.28-.26-.06Z",
    transform: "translate(-272.3 -39.64)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "589.09 375.2 549.47 371.48 553.64 317.04 593.25 320.76 589.09 375.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M867.71,422.34c-3.73.08-7.47.24-11.27.44l-11.6.61c-2,.12-4,.14-5.94.38s-4,.64-6,1a32.13,32.13,0,0,1-6.2.65,24.55,24.55,0,0,1-6.2-.88l-14.93-4,2.76-10.44a73.62,73.62,0,0,1,5.13-13.29c2.14-4.4,4.65-8.77,6.71-13.18a53.2,53.2,0,0,0,4.45-13.35,55.19,55.19,0,0,0,.78-6.78l.5-6.81v0h0c3.3.29,6.6.62,9.91.86l9.92.78c3.3.24,6.61.54,9.91.87a60.28,60.28,0,0,0,10,.17l.87,0,.09,1.19a72.35,72.35,0,0,0,3.09,14.95l2.61,8.6c.88,3,1.7,6.14,2.44,9.37a79.81,79.81,0,0,1,2,19.4c0,1.57-.13,3.11-.26,4.63a13.42,13.42,0,0,1-.75,4.23,3.63,3.63,0,0,1-2.67,2.14,6.18,6.18,0,0,1-2.23-.11l-.68-.19c-.24-.08-.5-.2-.75-.3A12.89,12.89,0,0,1,867.71,422.34Zm-12.64-15-1.56-2.56-1.3-2.19c-.78-1.34-1.4-2.46-2-3.51a29.28,29.28,0,0,1-2.14-4.66,6.18,6.18,0,0,1-.24-2.59,18.92,18.92,0,0,1,.27-2.17,17.3,17.3,0,0,1,4.07-7.81c1.09-1.31,2.26-2.72,3.48-4.25.61-.77,1.25-1.56,1.87-2.39s1.22-1.7,1.78-2.61a40.58,40.58,0,0,0,5.17-12.28l1,1.14a61.41,61.41,0,0,0-9.83-1.68c-3.3-.3-6.6-.61-9.9-1l-9.89-1.08c-3.29-.38-6.6-.67-9.9-1l0,0-.54,6.8a55.47,55.47,0,0,0-.26,6.82,53.16,53.16,0,0,0,2.37,13.87c1.37,4.67,3.18,9.37,4.63,14.05a72.71,72.71,0,0,1,3,13.92L823,397.71a8.74,8.74,0,0,1,3.71.05,15.71,15.71,0,0,1,3.7,1.58c1.27.66,2.6,1.39,3.92,1.92s2.63.88,4,1.31q4,1.24,8.2,2.48C849.33,405.86,852.19,406.64,855.07,407.34Z",
    transform: "translate(-272.3 -39.64)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.61,277.1c-3,5.25-8.16,8.44-13.33,8.08a12.54,12.54,0,0,1-6.6-2.53,12.34,12.34,0,0,0-5.47,4.09,13.27,13.27,0,0,0-2.16,8.16c.27,17-7.27,63.26-7.52,64.79-.46,2.78-1.23,7.21-2.42,12.69a.9.9,0,0,0,.2.49.6.6,0,0,0,.47.2l48.67-.26a.68.68,0,0,0,.66-.71c-.07-6.6-.41-16.21-1.29-18.81-2.56-7.64-4.71-22.42-3.1-53.69-.47-1.75-1.13-4.43-1.76-7.77-.54-2.8-.61-3.73-.89-5A20.75,20.75,0,0,0,857.61,277.1Z",
    transform: "translate(-272.3 -39.64)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M858.72,286.59a7.5,7.5,0,0,0,4.62-1.52,7.28,7.28,0,0,0,1.6-1.65l.06-.1,0,0,0,.06-.07.11-.16.23c-.42.62-.86,1.22-1.33,1.81a26,26,0,0,1-3.13,3.35,24.92,24.92,0,0,1-8.36,5,21.91,21.91,0,0,1-10.66,1,23.25,23.25,0,0,1-9.72-3.94l10,1.3c-.62.36-.74.7-.62.75s.26,0,.45.34c.1.19.23.41.41.79a2.21,2.21,0,0,1,.14.42,8.19,8.19,0,0,1,.14.82l.28,1.7.27,1.72c.08.54.14,1.07.2,1.61.13,1.07.23,2.17.28,3.22a31.84,31.84,0,0,1-.34,6.19c-.32,2-.8,4-1.31,6a101.78,101.78,0,0,1-3.75,11.6c-2.86,7.62-6.64,15-9.85,22.45-.83,1.86-1.56,3.72-2.31,5.59s-1.36,3.74-2,5.61a93.47,93.47,0,0,0-3.29,11.33v0a.67.67,0,0,0,.51.67c.31,0,.64,0,1,0h1.93l3.87,0,7.73-.05,15.47-.08,15.47-.09H869c.31,0,.68.06.91-.21s.19-.6.19-.91l0-1,0-1.93c-.06-2.58-.15-5.16-.3-7.73-.08-1.29-.17-2.57-.29-3.86-.07-.64-.14-1.28-.23-1.92-.06-.31-.09-.63-.16-.95a1.53,1.53,0,0,0-.14-.46,1.24,1.24,0,0,0-.49-.35,2.05,2.05,0,0,1-.54-.33,3,3,0,0,1-.31-.42c-.18-.29-.38-.58-.55-.87-.35-.59-.73-1.18-1.06-1.79-.67-1.21-1.33-2.43-2-3.68-1.24-2.51-2.45-5.06-3.56-7.66s-2.18-5.22-3.18-7.86c-2-5.29-3.86-10.65-5.35-16a126.9,126.9,0,0,1-3.33-16.15l.54,5.25c-.91-2.17-1.77-4.38-2.57-6.6-.41-1.12-.82-2.22-1.15-3.39-.17-.58-.34-1.18-.49-1.73a6.85,6.85,0,0,0-.37-1.16c-.08-.11-.08,0,0,0a.39.39,0,0,0,.25,0,3.34,3.34,0,0,0,1.19-.75,10.9,10.9,0,0,0,.89-.9c.19-.2.31-.39.5-.61s.36-.47.54-.73c.41-.55.78-1.14,1.25-1.89l.36-.57.17-.29a10.13,10.13,0,0,0,1.53,1,9.44,9.44,0,0,0,4,1A6.84,6.84,0,0,0,858.72,286.59Zm-2.21-19a9.18,9.18,0,0,1,4.06-.23,12.65,12.65,0,0,1,4.49,1.6,15.76,15.76,0,0,1,1.78,1.27h1.27a12.57,12.57,0,0,1,3.13.5c.49.15,1,.32,1.43.51a13.94,13.94,0,0,1,1.35.65,12.66,12.66,0,0,1,2.45,1.71,15.75,15.75,0,0,1,3.69,4.79,16.42,16.42,0,0,1,1.15,2.89,18.47,18.47,0,0,1,.61,3c.09.88.11,1.4.13,1.85l0,1.26c0,.84.07,1.71.11,2.57.09,1.72.12,3.47.11,5.26l.55,5.25c-1.26,4.91-2.75,9.83-4.38,14.75s-3.38,9.88-4.9,14.89A99.71,99.71,0,0,0,870,345.36c-.17,1.28-.32,2.58-.38,3.87-.05.66-.05,1.3-.07,2,0,.33,0,.65,0,1a2.14,2.14,0,0,1,0,.5,3.2,3.2,0,0,1-.26.6,1.66,1.66,0,0,0-.23.58,1.29,1.29,0,0,0,.06.48c.07.32.1.64.16.95.09.64.16,1.28.23,1.92.12,1.29.21,2.57.29,3.86.15,2.57.24,5.15.3,7.73l0,1.93,0,1c0,.31.06.67-.19.91s-.6.2-.91.21h-2.9l-15.47.09-15.47.08-7.73.05-3.87,0-1.93,0c-.32,0-.64,0-1,0a.75.75,0,0,1-.62-.71h0a79.47,79.47,0,0,0,.44-23.61c-.87-8-2.46-16.08-3.36-23.95-.49-3.94-.82-7.84-1-11.66-.06-1-.09-1.92-.12-2.87s-.08-1.88,0-2.82a32.24,32.24,0,0,1,.58-5.49c.17-.89.35-1.75.58-2.63l.65-2.52.3-1.22a6.6,6.6,0,0,0,.15-.66l.14-1a33.35,33.35,0,0,1,1-5,24.24,24.24,0,0,1,5.51-10.06,22.9,22.9,0,0,1,9-5.77l6.51-2.35,3.5,3.64a5,5,0,0,0,1,.81,1.38,1.38,0,0,0,1,.13,3.94,3.94,0,0,0,1.77-.87,6.48,6.48,0,0,0,.94-.89,4.94,4.94,0,0,0,.44-.56l0-.07,0,0v0l.1-.15a12.48,12.48,0,0,1,2-2.28A12.1,12.1,0,0,1,856.51,267.62Z",
    transform: "translate(-272.3 -39.64)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "472.61 283.35 474.11 275.65 535.15 289.28 533.64 296.98 472.61 283.35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M744.64,323.17c.45-2.63.93-5.3,1.45-7.94l0-.21.35,0a71.4,71.4,0,0,1,8.16-.67c2.69-.08,5.35-.06,8,.05a145.41,145.41,0,0,1,15.69,1.47,153.07,153.07,0,0,1,15.36,3,26.44,26.44,0,0,1,7.25,3.37,23.22,23.22,0,0,1,6.58,6.44l.24.37h0l-1.5,7.71-.39.25c-.47.62-1,1.33-1.44,1.87s-.94,1-1.41,1.52l-1.38,1.23c-.23.2-.47.42-.69.6l-.68.49a17.91,17.91,0,0,1-5.26,2.59,13,13,0,0,1-4.84.44,13.42,13.42,0,0,1-2.22-.44l-2.18-.56A126.3,126.3,0,0,1,769.09,339a99.4,99.4,0,0,1-14.29-7.41C750.66,328.85,747,326.14,744.64,323.17Zm.53-.35c7.85-.71,14.33-1.14,20.36-1.56s11.29-.63,16.23-.6a89.23,89.23,0,0,1,13.84,1.1l1.64.28a7.16,7.16,0,0,1,1.59.42,7.06,7.06,0,0,1,2.79,2.14,17.34,17.34,0,0,1,2.37,4.29l.27.71c.1.25.17.54.26.81l.53,1.65.5,1.95c.17.69.3,1.54.46,2.3l-.38.25,1.5-7.7.25.37a23.17,23.17,0,0,1-8.69,3,26.14,26.14,0,0,1-8,0,153.79,153.79,0,0,1-15.17-3.84A147.49,147.49,0,0,1,760.7,323c-2.44-1-4.86-2.14-7.26-3.36a69.69,69.69,0,0,1-7.1-4.08l.38-.25C746.24,317.84,745.72,320.31,745.17,322.82Z",
    transform: "translate(-272.3 -39.64)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M824.11,226.67c.18,6.62.51,18.73,8.92,25.47a20.17,20.17,0,0,0,10.71,4.24A21.1,21.1,0,0,0,858,252.23a22.9,22.9,0,0,0,6.07-6.95c2-3.51,2.13-5.93,3.65-15.21,1.92-11.69,2.24-11.21,2-12.5-1.66-8.72-12.9-14.33-21.77-15.34-3-.34-14.07-1.59-20.24,6.19C823.75,213.41,823.92,219.44,824.11,226.67Z",
    transform: "translate(-272.3 -39.64)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M820.76,200.38c-.6,4.76,4.61,9,5.22,9.44,3.52,2.77,6.38,2.39,19.94,1.8,11-.48,13.52-.43,17.44-2.61,1.09-.61,8.44-4.81,7.93-9-.33-2.82-4-4.44-7.35-5.69-5.23-1.94-11.05-2.08-19.6-2.3-7.82-.2-11.73-.29-15.62.81C826.41,193.45,821.31,196,820.76,200.38Z",
    transform: "translate(-272.3 -39.64)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.76,590.24c-3,5.76-9.25,7.24-14.18,8.4-5.37,1.27-18.05,2.88-20.05-2.82s7.64-14.74,12.7-18.47c3.12-2.31,10.46-7.73,16.66-5.14a10.39,10.39,0,0,1,4.91,4.65A14.62,14.62,0,0,1,878.76,590.24Z",
    transform: "translate(-272.3 -39.64)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "546.89 278.2 557.25 290.01 613.7 246.7 603.34 234.89 546.89 278.2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M819.51,317.87c3.47,3.86,6.88,7.69,10.28,11.57l-.44-.05a83.76,83.76,0,0,1,5.58-7.34q2.91-3.49,6-6.76c4.13-4.36,8.45-8.47,12.91-12.4,2.23-2,4.48-3.9,6.79-5.75,1.16-.93,2.31-1.86,3.48-2.77s2.33-1.84,3.56-2.67a34.25,34.25,0,0,1,8.09-4.06,30.94,30.94,0,0,1,4.69-1.2,23.28,23.28,0,0,1,5.33-.36l0,.47L875.4,274.74l.44,0a34.79,34.79,0,0,1,.87,7.9,16.54,16.54,0,0,1-.75,5.2,8.6,8.6,0,0,1-2,3.41,9.5,9.5,0,0,1-1.47,1.2l-1.57,1.1a114.87,114.87,0,0,1-13.76,8c-5,2.51-10.54,5-16.72,7.57S827.51,314.62,819.51,317.87Zm-.64-.06c1.41-4,4.16-8.35,7.32-12.95a134.09,134.09,0,0,1,11.51-14.08,157.12,157.12,0,0,1,14.46-13.65l2-1.61a17.31,17.31,0,0,1,2.06-1.51,15.72,15.72,0,0,1,5-2,18.67,18.67,0,0,1,6.31-.22,23.63,23.63,0,0,1,7.93,2.48l.44.05,10.35,11.81,0,0-.09.42a22.59,22.59,0,0,1-1.72,5.06,31.49,31.49,0,0,1-2.37,4.21,34.15,34.15,0,0,1-6,6.77c-1.11,1-2.31,1.85-3.49,2.75S870.2,307.15,869,308c-2.39,1.75-4.85,3.42-7.31,5.07-5,3.3-10,6.4-15.32,9.26q-4,2.14-8.09,4.07a86.14,86.14,0,0,1-8.54,3.48l-.31.11-.13-.15C825.8,325.87,822.31,321.82,818.87,317.81Z",
    transform: "translate(-272.3 -39.64)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "501.03 264.31 497.8 271.05 558.63 296.09 561.86 289.35 501.03 264.31"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M773.44,304.24c-1,2.22-2,4.4-3.06,6.58l-.16-.41a77.86,77.86,0,0,1,8.49,1q4.17.67,8.23,1.62,8.12,1.88,15.93,4.49c5.21,1.76,10.36,3.64,15.37,5.87a29.8,29.8,0,0,1,7,4.65,24.71,24.71,0,0,1,5.83,7.44l-.4.15,3.23-6.74.16.42c-.57.49-1.17,1.08-1.71,1.51L830.78,332l-1.41,1c-.23.15-.47.34-.69.47l-.65.39a16.88,16.88,0,0,1-4.57,1.93,7.75,7.75,0,0,1-3.71,0,8.5,8.5,0,0,1-1.66-.61l-1.61-.75a104.52,104.52,0,0,1-12.86-7.29c-4.35-2.86-8.85-6.15-13.77-9.93S779.63,309.31,773.44,304.24Zm-.22-.58c3.95-.89,8.81-.81,14-.46a116.31,116.31,0,0,1,16.64,2.59A143.37,143.37,0,0,1,821.43,311l2.18.82a15.13,15.13,0,0,1,2.15,1,14,14,0,0,1,3.89,3.14,18.46,18.46,0,0,1,3,5.06l.3.78c.1.27.18.58.26.87l.49,1.75c.14.65.24,1.35.35,2s.14,1.55.2,2.31l.16.41-3.23,6.74v0l-.39.13a24.81,24.81,0,0,1-9.37,1.17,29.61,29.61,0,0,1-8.23-1.61c-5.13-1.94-10.11-4.23-15.05-6.65s-9.75-5.1-14.48-8q-3.54-2.19-7-4.63A80.63,80.63,0,0,1,770,311l-.26-.23.09-.19C770.93,308.25,772.08,305.93,773.22,303.66Z",
    transform: "translate(-272.3 -39.64)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 487.84,
    cy: 249.39,
    r: 10.76
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M961.36,593.24c-.35,2.37-4.63,7.49-130.07,8.87-132.22,1.45-176-.46-241.45-.23-178.19.64-211.9,10.61-261.36-19.44-13.28-8.07-57.25-34.79-56.16-71.28.85-28.51,28.81-49.65,34.56-54,4.34-3.28,28.35-21.44,58.32-19.44,47,3.14,50.28,51.9,97.2,67,51.25,16.45,72.15-33.75,140.39-25.92,48.49,5.56,45.19,31.73,114.49,54,52.06,16.73,62.77,4.8,138.24,21.6C899.07,564.05,962.87,583,961.36,593.24Z",
    transform: "translate(-272.3 -39.64)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuevasolicitudCenfotec);
export default __webpack_public_path__ + "static/media/NuevasolicitudCenfotec.b8852a8445f120f0e539878260515438.svg";
export { ForwardRef as ReactComponent };